<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightHeader">
              <el-button @click="goback" size="small" type="primary"
                >{{$t('common.btn.goback')}}</el-button
              >
            </div>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('DictionaryManaged.dictValue')">
                    <el-input
                      size="mini"
                      v-model="formInline.dictValue"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DictionaryManaged.dictAdditionalValue')">
                    <el-input
                      size="mini"
                      v-model="formInline.dictAdditionalValue"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  type="text"
                  @click="editUser"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.edit')}}</el-button
                >
                <el-button
                  type="text"
                  @click="deleteUser"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.delete')}}</el-button
                >
                <el-button type="text" @click="addUser">{{$t('common.btn.add')}}</el-button>
                <el-button @click="ListSetting" type="text">{{$t('common.btn.listsetting')}}</el-button>
                <i-column
                  :listData="columns"
                  @changeSort="changeSort"
                  ref="listSet"
                ></i-column>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="dictValue"
            :label="$t('DictionaryManaged.dictValue')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.dictValue"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="dictAdditionalValue"
            :label="$t('DictionaryManaged.dictAdditionalValue')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.dictAdditionalValue"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="dictSort"
            :label="$t('DictionaryManaged.dictSort')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.dictSort"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="remarks"
            :label="$t('common.remark')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              type="textarea"
              size="small"
              v-model="form.remarks"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DictionaryItem from "./DictionaryItem";
export default DictionaryItem;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
